export const debugLog =
  // eslint-disable-next-line no-undef
  (process.env.NODE_ENV === 'development' || (typeof window !== 'undefined' && window?.['otelo-debug'])) ?
    // eslint-disable-next-line no-console
  console.debug :
    () => {};
